import { Result } from 'entities/result'
import _ from 'lodash'
import { ReactNode } from 'react'
import { ResultInfoV2, ResultV2ViewModel, RiskData, RiskScore } from './result_v2_view_model'
import { Symptom } from 'components/send_history/result_v2'
import { Sample } from 'entities/sample'

export type LungRiskScore = RiskScore & {
    smoking: number
    family_smoking: number
    COPD: number
    pneumonia: number
    tuberculosis: number
    BMI: number
    lung_family_history: number
}
type LungRiskRatio = LungRiskScore

type LungResultInfoV2 = ResultInfoV2 & {
    risk_score: LungRiskScore
    risk_ratio: LungRiskRatio
    risk_data: RiskData<LungRiskScore>
}

export class LungResultV2ViewModel extends ResultV2ViewModel {
    constructor(result: Result, sample: Sample) {
        super(result, '肺がん', '0.3%程度', '1%程度', sample)
    }
    public info(): LungResultInfoV2 {
        return super.info() as LungResultInfoV2
    }

    private hasCOPD = (): boolean => {
        return this.background.medicalHistories?.some((mh) => mh.disease === 'COPD') ?? false
    }

    private hasPneumonia = (): boolean => {
        return this.background.medicalHistories?.some((mh) => mh.disease === 'pneumonia') ?? false
    }

    private hasTuberculosis = (): boolean => {
        return this.background.medicalHistories?.some((mh) => mh.disease === 'tuberculosis') ?? false
    }

    public smoking = () => {
        if (this.background.smoking === 'now') {
            return '吸う'
        } else if (this.background.smoking === 'ever') {
            return 'やめた'
        } else {
            return '吸わない'
        }
    }

    public family_smoking = () => {
        if (this.background.familySmoking) {
            return '吸う'
        } else {
            return '吸わない'
        }
    }

    public COPD = () => {
        return this.hasCOPD() ? 'あり' : 'なし'
    }

    public pneumonia = () => {
        return this.hasPneumonia() ? 'あり' : 'なし'
    }

    public tuberculosis = () => {
        return this.hasTuberculosis() ? 'あり' : 'なし'
    }

    public lung_family_history = () => {
        const uniqCancers = _.uniq(this.background.familyHistories?.map((fh) => fh.cancer))
        if (uniqCancers.includes('lung')) {
            return '当てはまる'
        } else {
            return '該当なし'
        }
    }

    public getMiddleTextPosition(): { bottom: number; left: number } {
        return { bottom: 135, left: 125 }
    }
    public getHighTextPosition(): { top: number; right: number } {
        return { top: 2, right: 5 }
    }
    public symptomsView(symptoms: Symptom[]): ReactNode {
        return super.symptomsView(symptoms, 15)
    }
}
